<template>
  <div class="pa-3 legal-entity">
    <v-row>
      <v-col cols="12" md="6" class="px-md-3">
        <router-view></router-view>
      </v-col>
      <v-col cols="12" md="6" class="px-md-3">
        <GuidCard />
      </v-col>
    </v-row>
  </div>
</template>

<script>
// import ConfirmCompany from "@/components/LegalEntityManage/Create/ConfirmCompany.vue";

// import SetCompanyIdentity from "@/components/LegalEntityManage/Create/SetCompanyIdentity.vue";
// import SignList from "@/components/LegalEntityManage/Create/SignList.vue";
// import EndMeesage from "@/components/LegalEntityManage/Create/EndMeesage.vue";

import GuidCard from "@/components/LegalEntityManage/GuidCard.vue";

export default {
  components: { GuidCard }
};
</script>
